"use strict";
/**
 * Возвращает нужную форму слова в зависимости от числительного, которое находится перед словом.
 * Русская локаль используется по умолчанию, если локаль не указана в параметре
 *
 * @param {object} pluralObj
 * @param {number} value
 * @param {"ru" | "en" | "kk" | "ky" | "uz" | "hy"} locale
 * @param {Intl.PluralRulesOptions} options
 *
 * @returns {string}
*/let pr,localeCache;function getPlural(l,r,e="ru",t){if(localeCache!==e||t){if(!Intl.PluralRules.supportedLocalesOf([e],{localeMatcher:"lookup"}).length)throw Error(`Intl.PluralRules не поддерживает локаль "${e}"`);pr=new Intl.PluralRules(e,t),localeCache=e}t=pr.select(r);if(l.hasOwnProperty(t))return l[t];throw new Error(`Plural rule "${t}" не найдено в pluralObj`)}module.exports=getPlural;
